import { transformPressure } from './transform-pressure';
import { NormalizedUnitValue } from '../shared/types';
import { isCompositeDisplayUnit, toNumber } from '../shared/utils';

/**
 * Decodes a pre-composited psig-inhg source (negative → abs inHg magnitude,
 * non-negative → psig) when no target or a real target is requested. Composite
 * `newUnits` preserves the encoding for `formatPsigInhg` display.
 */
export function transformPsigInhg(
  unitValue: NormalizedUnitValue,
  newUnits?: string
): NormalizedUnitValue {
  const value = toNumber(unitValue.value);
  if (value == null) return unitValue;

  const resolved: NormalizedUnitValue =
    value < 0 ? { value: -value, units: 'inHg' } : { value, units: 'psig' };

  if (isCompositeDisplayUnit(newUnits)) {
    return unitValue;
  }

  if (!newUnits) {
    return resolved;
  }

  return transformPressure(resolved, newUnits);
}
